import { Box, Button, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import KanseiSimpleSelectBox from 'components/simpleSelectBox'
import KanseiTextField from 'components/textField'
import { companyApi } from 'hooks/api/company'
import { Company } from 'types/company'
import {
  CompanyBranch,
  CONTRACT_TYPE,
  CONTRACT_TYPE_OPTIONS,
  ContractType,
} from 'types/companyBranch'
import { REGION_OPTIONS } from 'types/region'

interface Form {
  id: string
  companyId: string
  branchName: string
  postalCode: string
  prefecture: number
  address: string
  phoneNumber: string
  faxNumber: string
  note: string
  contractType: ContractType
}

export default function BranchCreatePage() {
  const [company, setCompany] = useState<Company>()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<Form>()

  useEffect(() => {
    companyApi()
      .findById(id!)
      .then((res) => {
        setCompany(res.data)
      })
  }, [])

  const onSubmit = (form: Form) => {
    const data: CompanyBranch = {
      ...form,
      companyId: id!,
    } as CompanyBranch
    if (confirm('作成しますか？')) {
      companyApi()
        .addBranch(data)
        .then(() => {
          navigate(`/company/${id}`)
        })
    }
  }

  const links = [
    {
      title: '警備会社一覧',
      to: '/company',
    },
    {
      title: company ? company.name : '',
      to: `/company/${id}`,
    },
    {
      title: '支店新規作成',
    },
  ]

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <KanseiTextField
            id="branchName"
            label="支店名"
            control={control}
            errors={errors}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiTextField
            id="postalCode"
            label="郵便番号"
            control={control}
            errors={errors}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiSimpleSelectBox
            label="都道府県 *"
            options={REGION_OPTIONS}
            value={String(watch('prefecture') || '')}
            onChange={(value) => setValue('prefecture', Number(value))}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiSimpleSelectBox
            label="契約タイプ *"
            options={CONTRACT_TYPE_OPTIONS}
            value={String(watch('contractType') ?? CONTRACT_TYPE.FULL)}
            onChange={(value) =>
              setValue('contractType', Number(value) as ContractType)
            }
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiTextField
            id="address"
            label="住所"
            control={control}
            errors={errors}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiTextField
            id="phoneNumber"
            label="電話番号"
            control={control}
            errors={errors}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <KanseiTextField
            id="faxNumber"
            label="FAX番号"
            control={control}
            errors={errors}
          />
        </Grid>
        <Grid item xs={8}>
          <KanseiTextField
            id="note"
            label="備考"
            control={control}
            errors={errors}
            multiline
            rows={4}
          />
        </Grid>
      </Grid>
      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        作成
      </Button>
    </Box>
  )
}
